import React from 'react';
import env from '../../environment';

const IconAlert = (marginRight = 10) => (
  <i
    className="fa fa-exclamation-triangle"
    aria-hidden="true"
    style={{
      color: env.colors.secondary_300,
      marginRight: marginRight,
    }}
  />
);

export default IconAlert;
